//  测试环境1
//  生产环境互联网2
//  生产环境政务外网3
// let currentEnv = 1
let currentEnv = 2


export default currentEnv